export { default } from './NewsWebList';
